import {
    SystemState, UPDATE_SESSION, TOGGLE_LOADING_INDICATOR, SHOW_HEADER,
    SET_MESSAGE_RESPONSE, SHOW_MENUBAR, MessageResponse,SET_TITLE, RESET_TITLE,
    SHOW_FOOTER } from "./types";

export function updateSession(newSession: SystemState) {
    return {
        type: UPDATE_SESSION,
        payload: newSession
    };
}

export function toggleLoadingIndicator(showLoading: boolean) {
    return {
        type: TOGGLE_LOADING_INDICATOR,
        payload: showLoading
    };
}

export function setMessageResponse(messageResponse: MessageResponse | null) {
    return {
        type: SET_MESSAGE_RESPONSE,
        payload: messageResponse
    };
}

export function showHeader(showHeader: boolean) {
    return {
        type: SHOW_HEADER,
        payload: showHeader
    };
}

export function showMenubar(showMenubar: boolean) {
    return {
        type: SHOW_MENUBAR,
        payload: showMenubar
    };
}
export function setTitle(setTitle: string) {
    return {
        type: SET_TITLE,
        payload: setTitle
    };
}

export function resetTitle() {
    return {
        type: RESET_TITLE
    };
}

export function setShowFooter(showFooter: boolean) {
    return {
        type: SHOW_FOOTER,
        payload: showFooter
    };
}

